export enum EBannerType {
  SHARING_ANNOTATING = 'sharingAnnotating',
  CALCULATOR = 'calculator',
  RECORDING = 'recording',
}
